import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { formatVietnamCurrency } from '../../utils/numberFormatter';

interface PrepaidRecord {
    id: number;
    driverName: string;
    amount: number;
    prepaidDate: string;
    description?: string;
}

interface LinkPrepaidModalProps {
    isOpen: boolean;
    onClose: () => void;
    availableRecords: PrepaidRecord[];
    onLink: (id: number) => void;
}

const LinkPrepaidModal: React.FC<LinkPrepaidModalProps> = ({
    isOpen,
    onClose,
    availableRecords,
    onLink
}) => {
    const { t } = useLanguage();

    if (!isOpen) return null;

    return (
        <div className="modal show d-block" tabIndex={-1} style={{ background: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{t('link.prepaid.record')}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {availableRecords.length === 0 ? (
                            <p>{t('no.unlinked.prepaid.records')}</p>
                        ) : (
                            <div>
                                <p>{t('select.prepaid.record.to.link')}:</p>
                                {availableRecords.map(prepaid => (
                                    <div key={prepaid.id} className="border rounded p-2 mb-2 d-flex align-items-center justify-content-between">
                                        <div>
                                            <strong>{prepaid.driverName}</strong><br />
                                            <small>{t('amount')}: {formatVietnamCurrency(prepaid.amount)}</small><br />
                                            <small>{t('date')}: {new Date(prepaid.prepaidDate).toLocaleDateString()}</small>
                                            {prepaid.description && <br />}
                                            {prepaid.description && <small>{t('description')}: {prepaid.description}</small>}
                                        </div>
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() => onLink(prepaid.id)}
                                        >
                                            {t('link')}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>{t('cancel')}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LinkPrepaidModal;
